var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.71723 13.2349L2.62251 16.9552C2.5452 17.218 2.61632 17.4994 2.80805 17.6912C2.99979 17.8829 3.2812 17.954 3.54096 17.8798L7.26427 16.782C7.64774 16.6707 7.99718 16.4758 8.29715 16.213C8.34044 16.1759 8.38065 16.1357 8.42085 16.0955L17.8281 6.69133C18.5053 6.01408 18.5888 4.97192 18.0817 4.2019C18.0105 4.09367 17.9239 3.98853 17.8281 3.89266L16.6096 2.67114C15.8365 1.89803 14.5841 1.89803 13.811 2.67114L4.40376 12.0784C4.08214 12.4 3.84712 12.7989 3.71723 13.2349ZM5.13976 13.6524C5.19233 13.4792 5.27892 13.3184 5.39953 13.1824C5.41808 13.1638 5.43354 13.1453 5.4521 13.1267L14.7886 3.63294C14.9509 3.4679 15.2166 3.46679 15.3803 3.63047L16.8694 5.11959C17.0331 5.28328 17.032 5.54901 16.8669 5.71131L7.37251 15.0471C7.22716 15.1925 7.04471 15.3007 6.84679 15.3595L4.4285 16.0707L5.13976 13.6524Z",
    fill: "#086EC5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bbc8b6b87798d029e1551ca8ed129958.svg";
export { ForwardRef as ReactComponent };